export default __webpack_public_path__ + "static/media/upside-down-twokitty.6bbf8092.jpeg";